import { Container, Box, Fab } from "@material-ui/core";
import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Icon } from "shared";
import { Account } from "./components";
import { Area } from "types";
import { join } from "utils/misc";
import { Search } from "@material-ui/icons";

const Hcp: React.VFC = () => {
  const { state } = useLocation<string | undefined>();

  return (
    <div>
      <Box ml={3} my={3}>
        <Link to={join(Area.Hcps, state)}>
          <Fab color="secondary" size="medium" aria-label="Back to search">
            <Icon of={Search} />
          </Fab>
        </Link>
      </Box>
      <Container fixed>
        <Account />
      </Container>
    </div>
  );
};

export default Hcp;
